if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cartNotification = document.querySelector('cart-notification');
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      const submitButton = this.querySelector('[type="submit"]');
      if (submitButton.classList.contains('loading')) return; 

      this.handleErrorMessage();
      this.cartNotification.setActiveElement(document.activeElement);

      submitButton.setAttribute('aria-disabled', true);
      submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      config.body = JSON.stringify({
        ...JSON.parse(serializeForm(this.form)),
        sections: this.cartNotification.getSectionsToRender().map((section) => section.id),
        sections_url: window.location.pathname
      });

      if (submitButton.classList.contains('protein_offer_second')){
        let sellingPlanValue = document.querySelector('input[name="selling_plan"]').value;
        let fistProteinSelect = document.getElementById("Option-1");
        let fistProteinId = fistProteinSelect.value;
        
        let secondProteinSelect = document.getElementById("Option-2");
        let secondProteinId = secondProteinSelect.value;
        
        const items = [
          {
            id: fistProteinId, // Replace with actual variant ID
            quantity: 1,
            properties: {
              "__type": "two_pack"
            }
          },
          {
            id: secondProteinId, // Replace with actual variant ID
            quantity: 1,
            properties: {
              "__type": "two_pack"
            }
          },
        ];

        // **Explicitly add selling_plan if it's available**
        if (sellingPlanValue) {
          items.forEach(item => {
            item.selling_plan = sellingPlanValue;
          });
        }

        const config = {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ items }),
        };
        
        fetch('/cart/add.js', config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              this.handleErrorMessage(response.description);
              return;
            }
        
            window.location.href = '/cart';
            // this.cartNotification.renderContents(response);
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            submitButton.classList.remove('loading');
            submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading-overlay__spinner').classList.add('hidden');
          });
      }
      else if(submitButton.classList.contains('protein_offer_third')){
        let fistProteinSelect = document.getElementById("Option-3");
        let fistProteinId = fistProteinSelect.value;

        let secondProteinSelect = document.getElementById("Option-4");
        let secondProteinId = secondProteinSelect.value;

        let thirdProteinSelect = document.getElementById("Option-5");
        let thirdProteinId = thirdProteinSelect.value;
        
        const items = [
          {
            id: fistProteinId, // Replace with actual variant ID
            quantity: 1,
            properties: {
              "__type": "three_pack"
            },
          },
          {
            id: secondProteinId, // Replace with actual variant ID
            quantity: 1,
            properties: {
              "__type": "three_pack"
            },
          },
          {
            id: thirdProteinId, // Replace with actual variant ID
            quantity: 1,
            properties: {
              "__type": "three_pack"
            },
          },
        ];

        const config = {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ items }),
        };
        
        fetch('/cart/add.js', config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              this.handleErrorMessage(response.description);
              return;
            }
        
            window.location.href = '/cart';
            // this.cartNotification.renderContents(response);
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            submitButton.classList.remove('loading');
            submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading-overlay__spinner').classList.add('hidden');
          });
      }
      else{
        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              this.handleErrorMessage(response.description);
              return;
            }
  
            window.location.href='/cart';
            //this.cartNotification.renderContents(response);
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
          submitButton.classList.remove('loading');
          submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
      }
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
